import { useMsal } from "@azure/msal-react"
import { axiosPrivate } from "../api/axios"
import { useEffect } from "react"
import { AxiosError } from 'axios'
import { acquireToken } from "./useAcquireToken"

const useAxiosPrivate = () => {
    const { instance } = useMsal()
    const activeAccountId = instance.getActiveAccount()?.homeAccountId ?? null

    useEffect(() => {
        let accessToken: string
        const account = instance.getActiveAccount()

        const NO_ACTIVE_ACCOUNT = 'NO_ACTIVE_MSAL_ACCOUNT'

        const requestIntercept = axiosPrivate.interceptors.request.use(
            async config => {
                if (!config.headers['Authorization']) {
                    if (!account) {
                        const err: any = new Error(NO_ACTIVE_ACCOUNT)
                        err.code = NO_ACTIVE_ACCOUNT
                        err.silent = true
                        return Promise.reject(err)
                    }
                    if (!accessToken) {
                        accessToken = await acquireToken(instance, account)
                    }
                    config.headers['Authorization'] = `Bearer ${accessToken}`
                }
                return config
            },
            (error) => Promise.reject(error)
        )

        const responseIntercept = axiosPrivate.interceptors.response.use(
            response => response,
            async error => {
                const prevRequest = error?.config
                if (error?.response?.status === 401 && !prevRequest._retry && account) {
                    prevRequest._retry = true
                    try {
                        accessToken = await acquireToken(instance, account)
                        prevRequest.headers['Authorization'] = `Bearer ${accessToken}`
                        return axiosPrivate(prevRequest)
                    } catch (err) {
                        console.error("Token refresh failed", err)
                        return Promise.reject(error)
                    }
                }
                return Promise.reject(error)
            }
        )

        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept)
            axiosPrivate.interceptors.response.eject(responseIntercept)
        }
    }, [activeAccountId, instance])

    return axiosPrivate
}

export default useAxiosPrivate
export { AxiosError }